import { extraEn } from './extra-en.js';
import { extraEnMgmt } from './extra-en-mgmt.js';
import { extraHy } from './extra-hy.js';
import { extraRu } from './extra-ru.js';
import { deepMerge } from '../locale.js';

export const extrasEn = deepMerge(
  extraEn as unknown as Record<string, unknown>,
  extraEnMgmt as unknown as Record<string, unknown>,
);
export { extraHy as extrasHy, extraRu as extrasRu };
